import { ReactNode, useRef, useState } from "react";
import { Button, Drawer, Dropdown } from "antd";
import { useRecoilValue } from "recoil";
import { memberState, mobileState } from "../../state/atoms";
import { CloseCircleOutlined, DownOutlined, MoreOutlined } from "@ant-design/icons";
import { useOnClickOutside } from "usehooks-ts";
import React from "react";
import "./ScreenCard.scss";
import StartPlayingIcon from "../icons/StartPlayingIcon";
import CloseCircle from "../icons/CloseCircle";
import WiFiSignalOff from "../icons/WiFiSignalOff";

interface AvailableScreenCardProps {
  it: number;
  deactivateScreen: (it: number) => void;
  setSetupModal: (visible: boolean) => void;
  withTooltip: (tooltip: string, element: ReactNode) => ReactNode;
}

export default function AvailableScreenCard({
  it,
  deactivateScreen,
  setSetupModal,
  withTooltip
}: AvailableScreenCardProps) {
  const member = useRecoilValue(memberState);
  const mobile = useRecoilValue(mobileState);
  const [isMenuVisible, setMenuVisible] = useState(false);
  const menuRef = useRef(null);

  const [isMobileMenuVisible, setMobileMenuVisible] = useState(false);

  function hideDropdown() {
    setMenuVisible(false);
  }

  function hideMobileMenu() {
    setMobileMenuVisible(false);
  }

  const handleClickOutside = (ev: MouseEvent) => {
    hideDropdown();
  }

  useOnClickOutside(menuRef, (ev) => handleClickOutside(ev as MouseEvent));

  function onDeactivateScreenClick() {
    hideDropdown();
    hideMobileMenu();
    deactivateScreen(it);
  }

  const screenCardMenu = (
    <ul ref={menuRef}>
      <li className="deactivate" onClick={() => onDeactivateScreenClick()}><CloseCircleOutlined />Deactivate Screen</li>
    </ul>
  )

  const doubleDash = <>&mdash;&nbsp;&mdash;</>;

  return (<li className="screen" key={it}>
    <span className="status-col">
      <span className={"status-indicator"}>offline</span>
    </span>
    <span className="location-col">{doubleDash}</span>
    <span className="screen-col">
      {!mobile && <div className="playpause-btn offline">
        <div className="icon"><StartPlayingIcon/></div>
      </div>}
      <div className="thumbnail-container no-content">Unused<br/>Screen {it + 1}</div>
      &nbsp;&nbsp;&nbsp;<i>Screen Name</i>
      {mobile && <Button className={"secondary set-up"} onClick={() => setSetupModal(true)}>Set Up</Button>}
    </span>
    <span className="content-col"><Button className={"secondary"} onClick={() => setSetupModal(true)}>Set Up</Button></span>
    <span className="hdmi-col"><CloseCircle/></span>
    <span className="wifi-col">
      <div>
        <span><WiFiSignalOff/></span>
        <span>WiFi Unavailable</span>
      </div>
    </span>
    {!member.owner && <span className="locked-col"></span>}
    <span className="menu-col">
      {!mobile && withTooltip("More",
        <Dropdown
          visible={isMenuVisible}
          placement="bottomRight"
          arrow={false}
          getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
          overlayClassName="screen-edit-menu"
          overlay={screenCardMenu}
        >
          <div className="screen-edit-trigger">
            <MoreOutlined onClick={() => {
              setMenuVisible(!isMenuVisible)
            }}/>
          </div>
        </Dropdown>)}

      {mobile && <>
        <MoreOutlined onClick={() => {
          setMobileMenuVisible(!isMobileMenuVisible)
        }}/>
        <Drawer
          placement={"bottom"}
          visible={isMobileMenuVisible}
          onClose={() => setMobileMenuVisible(false)}
          closeIcon={<DownOutlined/>}
          className={"mobile-bottom-menu screen-edit-menu available-screen-menu"}
          height={180}>
          {screenCardMenu}
        </Drawer>
      </>}
    </span>
  </li>)
}
